import { ready } from "@rootreeweb/js-lib";

import pageManager from "./page-manager/index.js";
import pageSelect from "./pageSelect.js";
import videoPlayer from "./videoPlayer.js";

ready(() => {
	videoPlayer();
	pageSelect();
	pageManager();
});
